export default [
  {
    path: '/substitute/index',
    name: 'PageSubstituteIndex',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/substitute/PageSubstituteIndex'
      ),
    meta: { modular: 52, title: '调代课', info: '调代课——首页' }
  },
  {
    path: '/substitute/detail',
    name: 'PageSubstituteDetail',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/substitute/PageSubstituteDetail'
      ),
    meta: { modular: 52, title: '调代课详情', info: '调代课——详情' }
  },
  {
    path: '/substitute/record',
    name: 'PageSubstituteRecord',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/substitute/PageSubstituteRecord'
      ),
    meta: { modular: 52, title: '调代课记录', info: '调代课——记录' }
  },
  {
    path: '/substitute/arrange',
    name: 'PageSubstituteArrange',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/substitute/PageSubstituteArrange'
      ),
    meta: { modular: 52, title: '调代课安排', info: '调代课——安排' }
  }
]
